import {base64ToCanvas, canvasTo2dPixArray, canvasToBase64, pix2dArrayToCanvas} from "./imageHelpers";


export function clearTransparentBackground(base64) {
    return base64ToCanvas(base64)
        .then(doAndRemoveCanvas(canvasTo2dPixArray))
        .then(removeTransparentPixels)
        .then(pix2dArrayToCanvas)
        .then(doAndRemoveCanvas(canvasToBase64))
}

const doAndRemoveCanvas = action => canvas => {
    const res = action(canvas)
    canvas.remove()
    return res
}

Array.prototype.min = function(){
    return this.length ? this.reduce((min, cur) => Math.min(min, cur), this[0]) : null
}

function removeTransparentPixels(pixels2dArr) {
    console.log('2d', pixels2dArr)
    const filtered = pixels2dArr.map(row => row.filter(pix => pix[3] === 255)).filter(_ => _.length)
    const minW = filtered.map(_ => _.length).min()
    return filtered.map(row => row.slice(0, minW))
}

